export const translations = {
	nav: {
		title: 'Navigation',
		app: 'Donation Certificate',
	},
	footer: {
		poweredBy: 'Made by',
		copyright: '© {{year}} WorldCoo. All rights reserved.',
		termsAndConditions: 'Terms and Conditions',
		privacyPolicy: 'Privacy Policy',
	},
	categories: {
		basicNeeds: 'Water and Energy',
		humanRights: 'Human Rights',
		education: 'Education',
		emergency: 'Emergencies',
		feeding: 'Hunger and Food Security',
		environment: 'Environment',
		habitat: 'Housing and Poverty',
		health: 'Health',
	},
	statistics: {
		campaigns: 'Campaigns',
		donations: 'Donations',
		collected: 'Collected',
		collectedFromBudget: 'Goal of {{budget}}',
	},
	filters: {
		year: 'Year',
		state: 'State',
		cause: 'Cause',
		active: 'Active',
		finished: 'Finished',
		default: 'Default',
		toggle: 'Toggle {{value}}',
	},
	actions: {
		close: 'Close',
		search: 'Search anything',
		filter: 'Filter',
		viewCampaign: 'View campaign',
		makeDonation: 'Make donation',
		donate: 'Donate',
		selectLanguage: 'Select language',
		backToHome: 'Back to home',
		funded: 'Funded',
		clear: 'Clear Filters',
		apply: 'Apply',
		goBack: 'Back',
		previous: 'Previous',
		next: 'Next',
	},
	portal: {
		heroButton: 'Start donating',
		campaigns: {
			title: 'Campaigns',
			description: 'Explore our initiatives and choose the cause that inspires you most',
			notFound: 'No campaigns',
		},
		campaignFunded: 'Campaign funded',
		percentageFunded: '{{percentage}}% Funded',
		aCampaignFrom: 'A campaign from: {{ngoName}}',
		beneficiaries: 'Beneficiaries',
		directBeneficiaries: '{{count}} direct',
		indirectBeneficiaries: '{{count}} indirect',
		sdgs: {
			title: 'Sustainable Development Goals',
			1: 'No Poverty',
			2: 'Zero Hunger',
			3: 'Good Health and Well-being',
			4: 'Quality Education',
			5: 'Gender Equality',
			6: 'Clean Water and Sanitation',
			7: 'Affordable and Clean Energy',
			8: 'Decent Work and Economic Growth',
			9: 'Industry, Innovation and Infrastructure',
			10: 'Reduced Inequalities',
			11: 'Sustainable Cities and Communities',
			12: 'Responsible Consumption and Production',
			13: 'Climate Action',
			14: 'Life Below Water',
			15: 'Life on Land',
			16: 'Peace, Justice and Strong Institutions',
			17: 'Partnerships for the Goals',
		},
	},
	faq: {
		title: 'Frequently asked questions',
		description: 'Answers to the most common questions from our donors.',
	},
	campaign: {
		objectives: 'Campaign objectives',
		description: 'Description',
		activities: 'Activities',
		beneficiaries: 'Who will benefit?',
		updatesAndLinks: 'More information and links',
		from: 'From:',
		until: 'Until:',
	},
	campaigns: {
		notTranslated: 'This project is not yet available in your language.',
	},
	placeholders: {
		amount: 'Other amount',
	},
	donate: {
		title: 'Make your donation',
		details: {
			title: 'Add your details to proceed',
			subtitle: 'Fill in your details to complete your donation. You can also request your tax certificate here.',
		},
		certificate: {
			title: 'Recover up to {{amount}}',
			subtitle: 'Certify your donation with one click and it will automatically appear on your tax return draft.',
		},
	},
	errors: {
		required: 'This field is required',
		invalidExtref: 'The code is invalid, it must follow this format: {{format}}',
		email: 'The email address is badly formatted.',
		emailAlreadyExists: 'This email is already in use.',
		password: 'Your password must be 6 characters or more.',
		confirmationCode: 'Please enter the confirmation code.',
		documentType: 'Invalid document type',
		termsAndConditions: 'You must accept the terms and conditions',
		amount: 'Please select or enter a valid amount.',
		signIn: 'Error signing in',
		emailsDoNotMatch: 'Email addresses do not match.',
		passwordsDoNotMatch: 'Passwords do not match.',
		imageFormat: 'Please drop an image file',
		camera: 'Cannot access the camera. Please make sure you have granted permission.',
		expiredCode: 'The code has expired.',
		codeMismatch: 'The code is incorrect. Please try again.',
		notAuthorized: 'Incorrect credentials. Please try again.',
		userDoesNotExist: 'The user does not exist.',
		userNotConfirmed: 'User not confirmed. Please confirm your email address first.',
		userAlreadyConfirmed: 'The user has already been confirmed.',
		documentNumberExists: 'The document number is already in use.',
		limitExceeded: 'You have reached the attempt limit. Please try again later.',
		invalidPassword: 'The password is invalid, it must be at least 6 characters and cannot contain spaces.',
		captchaFailed: 'CAPTCHA verification failed. Please try again.',
		internal: 'Sorry, there was a problem, our team has already been informed, please try again later.',
	},
	documentTypes: {
		id: 'ID',
		passport: 'Passport',
		taxId: 'Tax Identification',
		nie: 'NIE',
		others: 'Others',
	},
	labels: {
		code: 'Code',
		email: 'Email',
		repeatEmail: 'Repeat your email',
		password: 'Password',
		confirmPassword: 'Confirm password',
		amount: 'Donation amount',
		documentType: 'Document type',
		documentNumber: 'Document number',
		name: 'Name',
		lastName: 'Last Name',
		streetName: 'Street name',
		streetNumber: 'Number',
		additionalInfo: 'Additional information',
		postalCode: 'Postal code',
		city: 'City',
		country: 'Country',
		region: 'Region',
		province: 'Province',
		certificate: 'I want to receive a tax certificate',
		termsAndConditions1:
			'This information will only be shared with the organizations receiving your donations in order to generate the corresponding tax certificate. Read the ',
		termsAndConditions2: 'terms and conditions',
		language: 'Language',
		newsletter:
			'Subscribe to stay up to date with the causes we support, the projects we fund, and the people we empower around the world.',
	},
	checkout: {
		title: 'Payment method',
	},
	recaptcha: {
		description: 'protected by reCAPTCHA.',
		privacy: 'Privacy',
		terms: 'Terms',
	},
	thanks: {
		title: 'Thank you\n for your donation!',
		description:
			'You will soon receive a confirmation email with all the details. Together we are building a better future!',
	},
	termsAndConditions: {
		title: 'Data Protection Terms',
		labelText: 'I have read, understand and accept the terms of ',
		labelLink: 'Data Protection of {{name}}',
		accept: 'I have read, understand and accept',
		responsible: {
			title: 'Responsible',
			description: 'WORLDCOO S.L.',
		},
		purpose: {
			title: 'Purpose',
			description:
				'Manage the business relationship in all its areas, as well as your donation and your certificate request, and the sending of commercial communications by electronic means.',
			descriptionNgo:
				'Fundraising for NGO projects, keeping you informed about the NGO and the evolution of the project for which you have donated funds and issuing tax deduction certificates.',
		},
		legitimacy: {
			title: 'Legitimacy',
			description: 'The legal basis for processing your data is obtaining your consent.',
		},
		recipients: {
			title: 'Recipients',
			description: 'Data will not be transferred to third parties unless there is a legal obligation to do so.',
		},
		rights: {
			title: 'Rights',
			description:
				'You have the right to access, rectify and delete data, as well as other rights, as explained in the additional information.',
		},
		additionalInfo: {
			title: 'Additional information',
			description:
				'You can consult additional and detailed information about Data Protection on our page <a href="https://www.worldcoo.com/gdpr">web</a> or by contacting <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>.',
			descriptionNgo:
				"You can consult the additional and detailed information about Data Protection on each NGO's website.\n\n<b>{{ngoName}}</b>",
		},
	},
};
